module.exports = __webpack_public_path__ + "static/understanding-pricing-9a6bce6d4b7e9b563af373ce23bd7002.png";